<template>
  <div class="search-box padding_top_bottom">
    <SearchEl @search-input-enter="searchInputEnter"></SearchEl>

    <component
      ref="resultEl"
      :is="componentName"
      @search-input-enter="searchInputEnter"
    ></component>
    <!-- <Record v-if="componentName === 'Record'"></Record>
        <SearchResult v-else ref='resultel'></SearchResult> -->
  </div>
</template>
<script>
import SearchEl from './components/SearchEl.vue';
import Record from './components/Record.vue';
import SearchResult from './components/SearchResult.vue';
import { search } from '@/api/ajax.js';
export default {
  name: '',

  data() {
    return {
      componentName: 'Record'
    };
  },
  watch: {},
  methods: {
    searchInputEnter() {
      this.componentName = 'SearchResult';

      this.$nextTick(() => {
        this.$refs.resultEl.onSubmit();
      });
    }
  },
  computed: {},
  components: {
    SearchEl,
    Record,
    SearchResult
  },
  created() {}
};
</script>

<style lang="less" scoped>
.search-box {
}
</style>
